module.exports = __webpack_public_path__ + "img/img9.ee8f6701.png";